import React from "react";
import { Box, Typography } from "@mui/material";

export default function MainImage({ mainImage }) {
  if (!mainImage) return null;

  return (
    <Box mb={3} textAlign="center">
      <Box
        component="img"
        src={mainImage.image_url}
        alt="Main Product"
        sx={{ maxWidth: "100%", maxHeight: 300, borderRadius: 1, border: "1px solid #ccc" }}
      />
    </Box>
  );
}
